import React from "react";

import EditViewSwitch from "../FormComponent/EditViewSwitch";

const TabsNavigation = (props) => {
  return (
    <div className="tabs d-flex ">
      {props.content.map((tabItem, index) => (
        <div
          key={index}
          className={[
            "is-size-body-1 bold px-5 pb-4 pt-6",
            props.activeTab === tabItem.tabId ? "active" : null,
          ].join(" ")}
          onClick={() =>
            props.changeTabHandler(tabItem.tabId, tabItem.tabSections)
          }
        >
          {tabItem.tabTitle}
        </div>
      ))}
      {(props.contentLength < 5) & !props.ViewMode ? (
        <div
          className="is-size-body-1 add-tab px-5 pt-1 mx-5"
          onClick={props.addTabHandler}
        >
          + Add New Tab
        </div>
      ) : null}
      {props.hideIcon ? null : 
        <EditViewSwitch
        editView={props.editView}
        hasValidValue={props.hasValidValue}
        toggleEditHandler={props.toggleEditHandler}
        toggleViewHandler={props.toggleViewHandler}
      />
      }
     
    </div>
  );
};

export default TabsNavigation;
